import React, { useEffect, useState, useCallback } from 'react';
import { FaCopy } from "react-icons/fa6";
import { toast } from 'react-toastify';

const MainComponent = () => {
    const [inputText, setInputText] = useState("");
    const [outputText, setOutputText] = useState("");

    const handleTextConvert = useCallback(() => {
        const text = inputText;
        const sanitizedText = text.replace(/['",]/g, '');
        const textArray = sanitizedText.split(" ");

        console.log({ textArray });
        let result = "";
        textArray.forEach((word) => {
            result += word.charAt(0).toUpperCase() + word.slice(1) + "_";
        });
        result = result.slice(0, -1);
        if (result.endsWith("_")) {
            result = result.slice(0, -1);
        }
        if (result.endsWith(".")) {
            result = result.slice(0, -1);
        }

        result = result + ".cpp";
        setOutputText(result);
    }, [inputText]);

    useEffect(() => {
        handleTextConvert();
    }, [inputText, handleTextConvert]);

    const handleCopy = () => {
        navigator.clipboard.writeText(outputText);
        toast.success("Copied to clipboard");
    };

    const handleClearButton = () => {
        setInputText("");
        setOutputText("");
    };

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "3rem 0",
                flexDirection: "column",
            }}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "50vw",
                }}
            >
                <input
                    style={{
                        height: "3rem",
                        borderRadius: "10px",
                        fontWeight: "bold",
                        fontSize: "20px",
                        paddingLeft: "15px"
                    }}
                    type="text"
                    value={inputText}
                    onChange={(e) => setInputText(e.target.value)}
                />
                <button
                    style={{
                        marginTop: "1rem",
                        height: "3rem",
                        borderRadius: "10px",
                        fontSize: "22px",
                        fontWeight: "bold",
                        cursor: "pointer",
                    }}
                    onClick={handleClearButton}
                >Clear</button>

                <button
                    style={{
                        marginTop: "1rem",
                        height: "3rem",
                        borderRadius: "10px",
                        fontSize: "22px",
                        fontWeight: "bold",
                        cursor: "pointer",
                    }}
                    onClick={handleTextConvert}
                >Convert</button>
            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "3rem 0",
                    flexDirection: "column",
                    border: "2px solid black",
                    padding: "4rem",
                    fontSize: "25px",
                    fontWeight: "bold",
                }}
            >
                <div>{outputText}</div>
            </div>
            <div
                style={{
                    fontSize: "40px",
                    border: "2px solid black",
                    padding: "1rem",
                    cursor: "pointer",
                }}
                onClick={handleCopy}
            ><FaCopy /></div>
        </div>
    )
}

export default MainComponent;
